import './App.css';

// react-router-dom import
import {
  Route,
  Navigate,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements
} from 'react-router-dom';

// Pages import
import Error from './Pages/Error';
import Home from './Pages/Home';
import Men from './Pages/Men';
import Women from './Pages/Women';
import Admin from './Pages/Admin'

// RootLayout import
import RootLayout from './Layouts/RootLayout';

// Chakra Ui Imp
import { ChakraProvider } from '@chakra-ui/react';
import axios from 'axios';
import { useEffect } from 'react';
import AppProvider, { AppState } from './Context/AppProvider';
import AboutUs from './Pages/AboutUs';

// router paths
const router= createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' errorElement={<Error/>}>
      <Route path='/' element={<RootLayout/>}  >
        <Route index element={<Home/>}/>
        <Route index path='/men' element={<Men/>}/>
        <Route index path='/women' element={<Women/>}/>
        <Route path='/about-us' element={<AboutUs/>}/>
        <Route path='/about us' element={<Navigate to='/about-us' replace/>}/>
      </Route>
      <Route path='/admin' element={<Admin/>}/>
    </Route>
  )  
)

function DataLoader() {
  const { setData } = AppState();
  useEffect(() => {
    let mounted = true;
    async function getData() {
      try {
        const res = await axios.get('/all');
        if (!mounted) return;
        if (res && Array.isArray(res.data)) setData(res.data);
        else setData([]);
      } catch (err) {
        // backend may be offline in local preview
        setData([]);
      }
    }
    getData();
    return () => { mounted = false };
  }, [setData]);
  return null;
}

function App() {
  return (
    <AppProvider>
      <ChakraProvider>
        <DataLoader />
        <RouterProvider router={router} />
      </ChakraProvider>
    </AppProvider>
  );
}

export default App;